import { useRouter } from "next/navigation"

export default useRouter
